module.exports = __webpack_public_path__ + "img/Presets Icon_Down.f93c4652.svg";